import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 text-sm text-gray-600" }

import { computed } from 'vue';
import LlSelect from '@/components/LlSelect.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LlDataTablePagination',
  props: {
  page: { type: Number, required: true },
  pageSize: { type: Number, required: true },
  totalCount: { type: Number, default: 0 },
  pageSizeOptions: { type: Array, default: () => [10, 20, 50] },
  sticky: { type: Boolean, default: false },
  // Fits a toolbar of small buttons. Compact density still draws the page size select
  // 40px tall; this draws it 28px, a small button's height. It also hides LlSelect's empty
  // label, which Bootstrap's global `label` rule turns into a 5px gap above the field.
  dense: { type: Boolean, default: false },
},
  emits: ['update:page', 'update:pageSize'],
  setup(__props) {

// Reusable pagination footer shared across list pages (see LlDataTable for
// context). Placement varies per page today - Fixed Fees/Time Entries put
// this in a top action bar, Matters pins it to the bottom - so this stays a
// separate component the consuming page positions itself, with `sticky`
// only turning on the bottom-pinned treatment Matters needs.
const props = __props;



const totalPages = computed(() => Math.ceil(props.totalCount / props.pageSize));

const rangeLabel = computed(() => {
  if (!props.totalCount) return '0 of 0';
  const start = (props.page - 1) * props.pageSize + 1;
  const end = Math.min(props.page * props.pageSize, props.totalCount);
  return `${start}–${end} of ${props.totalCount}`;
});

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ll-data-table-pagination flex items-center justify-between gap-4", { 'll-data-table-pagination--sticky': __props.sticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createTextVNode(" Items per page ", -1)),
      _createVNode(LlSelect, {
        "model-value": __props.pageSize,
        items: __props.pageSizeOptions,
        "return-object": false,
        density: "compact",
        "hide-details": "",
        class: _normalizeClass([
          'w-24',
          __props.dense &&
            '[&>label]:!hidden [&_.v-input]:![--v-input-control-height:28px] [&_.v-input]:![--v-input-padding-top:2px] [&_.v-field]:![--v-field-padding-bottom:2px]',
        ]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:pageSize', $event)))
      }, null, 8, ["model-value", "items", "class"]),
      _createElementVNode("span", null, _toDisplayString(rangeLabel.value), 1)
    ]),
    _createVNode(_component_v_pagination, {
      "model-value": __props.page,
      length: totalPages.value || 1,
      "total-visible": 5,
      density: "compact",
      "hide-details": "",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:page', $event)))
    }, null, 8, ["model-value", "length"])
  ], 2))
}
}

})